import { MODEL_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/modelSources'

/**
 * Reports whether a provider ships any schema for an action, ignoring the
 * `active_if` constraints - i.e. whether the engine can run the action at all,
 * regardless of the settings currently selected.
 *
 * @param {string} action - Generation action, e.g. ACTION.IMAGE_TO_3D.
 * @param {string} provider - Provider id, e.g. PROVIDER.TENCENT.
 * @returns {boolean}
 */
export const providerSupportsAction = (action, provider) => MODEL_SOURCES.some((schema) => (
  schema.action === action && schema.provider === provider
))
